import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import realisedService from 'services/realised.service';
import { userStore } from 'store/UserStore';
import downArrow from 'assets/icons/chevron-down.svg';
import upArrow from 'assets/icons/chevron-up.svg';
import Layout from '../../wrappers/layout';
import PageHeader from 'shared/page-header';
import Loader from 'shared/common/loader';
// import './style.css';

interface PropsType {}

const Analytics: React.FC<PropsType> = ({}) => {
  // eslint-disable-next-line
  const [realisedLoading, setRealisedLoading] = useState<boolean>(false);
  const [holdings, setHoldings] = useState([]);
  const [open, setOpen] = useState<any>(false);
  const [realisedData, setRealisedData] = useState<any>();
  const [unRealisedData, setUnRealisedData] = useState<any>();
  const [customerId, user, customer] = userStore((state: any) => [
    state.customerId,
    state.user,
    state.customer,
  ]);
  const metalsWithCode = [
    { code: 'Au', name: 'Gold' },
    { code: 'Ag', name: 'Silver' },
    { code: 'Pt', name: 'Platinum' },
    { code: 'Pd', name: 'Palladium' },
  ];

  const profitLoss = async () => {
    try {
      const data = { customerId: customerId };
      setRealisedLoading(true);
      const res = await realisedService.realisedData(
        data,
        user?.userId,
        user?.partner?.id
      );
      if (res.status == 200) {
        const newdata: Object = res.data.data.Realised;
        // arrayOfObjects = Object.entries(newdata).map(([key, value]) => ({
        //   metal: key,
        //   ...value,
        // }));
        setRealisedData(res?.data?.data?.Realised);
        setUnRealisedData(res?.data?.data?.Unrealised);
        setRealisedLoading(false);

        // console.log('realiseddata', arrayOfObjects);
      } else {
        // setRealisedLoading(false);

        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      setRealisedLoading(false);

      toast.error('Something went wrong');
    }
  };

  const investedMetalSum =
    realisedData &&
    Object.keys(realisedData)?.reduce(
      (acc, metal) => acc + realisedData[metal]?.sell_price,
      0
    );
  const markToMarkSum =
    unRealisedData &&
    Object.keys(unRealisedData)?.reduce(
      (acc, metal) => acc + unRealisedData[metal].totalSellAmount,
      0
    );
  const unInvestedSum =
    unRealisedData &&
    Object.keys(unRealisedData)?.reduce(
      (acc, metal) => acc + unRealisedData[metal].totalBuybackAmount,
      0
    );

  const realisedMetalSum =
    realisedData &&
    Object.keys(realisedData)?.reduce(
      (acc, metal) => acc + realisedData[metal]?.buyback_price,
      0
    );

  const realisedPLSum = realisedMetalSum - investedMetalSum;
  const unrealisedPLSum = markToMarkSum - unInvestedSum;
  const realisedPLSumPer =
    investedMetalSum > 0
      ? ((realisedMetalSum - investedMetalSum) / investedMetalSum) * 100
      : realisedMetalSum > 0
      ? 100
      : 0;
  const unrealisedPLSumPer =
    unInvestedSum > 0
      ? ((markToMarkSum - unInvestedSum) / unInvestedSum) * 100
      : markToMarkSum > 0
      ? 100
      : 0;

  useEffect(() => {
     document.title = 'Analytics - CoinBazaar Digital';
    profitLoss();
  }, []);

  return (
    <Layout>
      <PageHeader
        mainTitle='Analytics'
        subTitle='Your transaction analysis is given below'
      ></PageHeader>
      <Row className='mt-5 mb-3'>
        {realisedLoading ? (
          <Loader />
        ) : (
          realisedData && (
            <>
              <Col md={6}>
                <h5>BOOKED GAIN / LOSS</h5>
                <div className='table-real-container overflow-auto'>
                  <table className='custom-table' style={{ height: 300 }}>
                    <thead>
                      <tr>
                        <th className='center-align'>Metal</th>
                        {realisedData &&
                          Object.keys(realisedData).map((metalCode) => {
                            const metalObject = metalsWithCode?.find(
                              (metal) => metal?.code === metalCode
                            );
                            const metalName = metalObject
                              ? metalObject?.name
                              : metalCode;
                            return (
                              <th key={metalCode} className='center-align'>
                                {metalName}
                              </th>
                            );
                          })}
                        <th className='center-align'>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className='left-align'>
                          <b>Invested Metal Value</b>
                        </td>
                        {Object.keys(realisedData).map((metal) => (
                          <td key={`${metal}-sold`} className='right-align'>
                            ₹{realisedData[metal].sell_price.toFixed(2)}
                          </td>
                        ))}
                        <td className='right-align'>
                          ₹{investedMetalSum.toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td className='left-align'>
                          <b>Realised Metal Value</b>
                        </td>

                        {realisedData &&
                          Object.keys(realisedData).map((metal) => (
                            <td
                              key={`${metal}-investment`}
                              className='right-align'
                            >
                              ₹{realisedData[metal].buyback_price.toFixed(2)}
                            </td>
                          ))}
                        <td className='right-align'>
                          ₹{realisedMetalSum.toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Metal Transacted</b>
                        </td>
                        {realisedData &&
                          Object.keys(realisedData).map((metal) => (
                            <td key={`${metal}-invst`} className='right-align'>
                              {realisedData[metal].quantity.toFixed(4)} g
                            </td>
                          ))}
                        <td className='center-align'>-</td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Gain / Loss (INR)</b>
                        </td>
                        {realisedData &&
                          Object.keys(realisedData).map((metal) => (
                            <td
                              key={`${metal}-pp`}
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {realisedData[metal].buyback_price.toFixed(2) -
                                  realisedData[metal].sell_price.toFixed(2) !=
                                0 ? (
                                  realisedData[metal].buyback_price.toFixed(2) -
                                    realisedData[metal].sell_price.toFixed(2) >
                                  0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  ₹
                                  {Math.abs(
                                    realisedData[metal].buyback_price -
                                      realisedData[metal].sell_price
                                  ).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          ))}
                        <td className='right-align' style={{ padding: '5px' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {realisedPLSum != 0 ? (
                              realisedPLSum > 0 ? (
                                <img
                                  src={upArrow}
                                  className='arrow-icon'
                                  style={{
                                    marginRight: '5px',
                                    marginBottom: '-4px',
                                  }}
                                />
                              ) : (
                                <img
                                  src={downArrow}
                                  className='arrow-icon'
                                  style={{
                                    marginRight: '5px',
                                    marginBottom: '-4px',
                                  }}
                                />
                              )
                            ) : (
                              ''
                            )}
                            <span>₹{Math.abs(realisedPLSum).toFixed(2)}</span>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Gain / Loss (%)</b>
                        </td>
                        {realisedData &&
                          Object.keys(realisedData).map((metal) => (
                            <td
                              key={`${metal}-pp`}
                              className='right-align'
                              style={{ padding: '5px' }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {realisedData[metal].buyback_price.toFixed(2) -
                                  realisedData[metal].sell_price.toFixed(2) !=
                                0 ? (
                                  realisedData[metal].buyback_price.toFixed(2) -
                                    realisedData[metal].sell_price.toFixed(2) >
                                  0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  {realisedData[metal].sell_price > 0
                                    ? Math.abs(
                                        ((realisedData[metal].buyback_price -
                                          realisedData[metal].sell_price) /
                                          realisedData[metal].sell_price) *
                                          100
                                      ).toFixed(2)
                                    : realisedData[metal].buyback_price > 0
                                    ? 100
                                    : 0}
                                  %
                                </span>
                              </div>
                            </td>
                          ))}
                        {/* <td className='center-align'>-</td> */}
                        <td className='right-align' style={{ padding: '5px' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {realisedPLSumPer !== 0 ? (
                              <>
                                {realisedPLSumPer > 0 ? (
                                  <img
                                    src={upArrow}
                                    className='arrow-icon'
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={downArrow}
                                    className='arrow-icon'
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                              ''
                            )}
                            <span>
                              {realisedPLSumPer !== 0
                                ? Math.abs(realisedPLSumPer).toFixed(2)
                                : 0}
                              %
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col md={6} className='mob-table-margin'>
                <h5>POTENTIAL GAIN / LOSS</h5>
                <div className='table-real-container overflow-auto'>
                  <table className='custom-table' style={{ height: 300 }}>
                    <thead>
                      <tr>
                        <th className='center-align'>Metal</th>
                        {realisedData &&
                          Object.keys(realisedData).map((metalCode) => {
                            const metalObject = metalsWithCode.find(
                              (metal) => metal.code === metalCode
                            );
                            const metalName = metalObject
                              ? metalObject.name
                              : metalCode;
                            return (
                              <th key={metalCode} className='center-align'>
                                {metalName}
                              </th>
                            );
                          })}
                        <th className='center-align'>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className='left-align'>
                          <b>Investment value</b>
                        </td>
                        {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td key={`${metal}-invst`} className='right-align'>
                              ₹
                              {unRealisedData[metal].totalBuybackAmount.toFixed(
                                2
                              )}
                            </td>
                          ))}
                        <td className='right-align'>
                          ₹{Math.abs(unInvestedSum).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Mark to Market value</b>
                        </td>
                        {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td key={`${metal}-invst`} className='right-align'>
                              ₹
                              {unRealisedData[metal].totalSellAmount.toFixed(2)}
                            </td>
                          ))}
                        <td className='right-align'>
                          ₹{Math.abs(markToMarkSum).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Metal Holdings</b>
                        </td>
                        {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td key={`${metal}-invst`} className='right-align'>
                              {unRealisedData[metal].totalSellQuantity.toFixed(
                                4
                              )}
                              g
                            </td>
                          ))}
                        <td className='center-align'>-</td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Gain / Loss (INR)</b>
                        </td>
                        {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td
                              key={`${metal}-pp`}
                              style={{ padding: '5px' }}
                              className='right-align'
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {unRealisedData[metal].totalSellAmount -
                                  unRealisedData[metal].totalBuybackAmount !=
                                0 ? (
                                  unRealisedData[metal].totalSellAmount -
                                    unRealisedData[metal].totalBuybackAmount >
                                  0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span>
                                  ₹
                                  {Math.abs(
                                    unRealisedData[metal].totalSellAmount -
                                      unRealisedData[metal].totalBuybackAmount
                                  ).toFixed(2)}
                                </span>
                              </div>
                            </td>
                          ))}
                        <td className='right-align' style={{ padding: '5px' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {unrealisedPLSum != 0 ? (
                              unrealisedPLSum > 0 ? (
                                <img
                                  src={upArrow}
                                  className='arrow-icon'
                                  style={{
                                    marginRight: '5px',
                                    marginBottom: '-4px',
                                  }}
                                />
                              ) : (
                                <img
                                  src={downArrow}
                                  className='arrow-icon'
                                  style={{
                                    marginRight: '5px',
                                    marginBottom: '-4px',
                                  }}
                                />
                              )
                            ) : (
                              ''
                            )}
                            <span>₹{Math.abs(unrealisedPLSum).toFixed(2)}</span>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td className='left-align'>
                          <b>Gain / Loss (%)</b>
                        </td>
                        {unRealisedData &&
                          Object.keys(unRealisedData).map((metal) => (
                            <td
                              key={`${metal}-pp`}
                              style={{ padding: '5px' }}
                              className='right-align'
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {unRealisedData[metal].totalSellAmount.toFixed(
                                  2
                                ) -
                                  unRealisedData[
                                    metal
                                  ].totalBuybackAmount.toFixed(2) !=
                                0 ? (
                                  unRealisedData[metal].totalSellAmount.toFixed(
                                    2
                                  ) -
                                    unRealisedData[
                                      metal
                                    ].totalBuybackAmount.toFixed(2) >
                                  0 ? (
                                    <img
                                      src={upArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={downArrow}
                                      className='arrow-icon'
                                      style={{
                                        marginRight: '5px',
                                        marginBottom: '-4px',
                                      }}
                                    />
                                  )
                                ) : (
                                  ''
                                )}
                                <span className='right-align'>
                                  {unRealisedData[metal].totalBuybackAmount > 0
                                    ? Math.abs(
                                        ((unRealisedData[metal]
                                          .totalSellAmount -
                                          unRealisedData[metal]
                                            .totalBuybackAmount) /
                                          unRealisedData[metal]
                                            .totalBuybackAmount) *
                                          100
                                      ).toFixed(2)
                                    : unRealisedData[metal].totalSellAmount > 0
                                    ? 100
                                    : 0}
                                  %
                                </span>
                              </div>
                            </td>
                          ))}
                        {/* <td className='center-align'>-</td> */}
                        <td className='right-align' style={{ padding: '5px' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-end',
                            }}
                          >
                            {unrealisedPLSumPer !== 0 ? (
                              <>
                                {unrealisedPLSumPer > 0 ? (
                                  <img
                                    src={upArrow}
                                    className='arrow-icon'
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={downArrow}
                                    className='arrow-icon'
                                    style={{
                                      marginRight: '5px',
                                      marginBottom: '-4px',
                                    }}
                                  />
                                )}
                              </>
                            ) : (
                              ''
                            )}
                            <span>
                              {unrealisedPLSumPer !== 0
                                ? Math.abs(unrealisedPLSumPer).toFixed(2)
                                : 0}
                              %
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
              {/* <div className='mt-2 text-center' style={{ fontSize: '14px' }}>
                *Note: Gifts are currently displayed as an investment by the
                sender, resulting in a deficit for the sender, and as a gains
                for the recipient.
              </div> */}
            </>
          )
        )}
      </Row>
    </Layout>
  );
};

export default Analytics;
